import { Injectable } from "@angular/core";
import * as firebase from "firebase/app";
import { DocumentData, Firestore, collection, collectionData, query, where } from "@angular/fire/firestore";
import * as moment from 'moment';
import { Question, Response, Questionaire } from "../models/questionaire";
import { lastValueFrom, map } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class QuestionaireService {

  constructor(
    public afs: Firestore

  ) { }

  getQuestionaireByType(type: string) {

    return collectionData(query(collection(this.afs, "questionaires"), where('type', '==', type))).pipe(map(data => {
      const questionaires: Questionaire[] = [];
      data.forEach(qr => {
        const questionaire = this.getQuestionaireObj(qr);
        questionaires.push(questionaire);
      });
      return questionaires;
    }));

  }

  getQuestionaireObj(qr): Questionaire {
    const questionaire = new Questionaire();
    questionaire.docId = qr.id;
    questionaire.type = qr.type;
    questionaire.questions = [];
    qr.questions.forEach(e => {
      const question = new Question();
      question.isMultiSelect = e.isMultiSelect;
      question.showInterests = e.showInterests;
      question.type = e.type;
      question.valueType = e.valueType;
      question.question = e.question;
      question.start = e.start;
      question.end = e.end;
      question.values = e.values;
      question.responses = [];
      const responseMap = e.responses;
      for (const key in responseMap) {
        const value = responseMap[key];
        const response = new Response();
        response.num = +key;
        response.response = value;
        question.responses.push(response);
      }
      questionaire.questions.push(question);
    });
    return questionaire;
  }

}
